import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Flex,
  Grid,
  GridItem,
  Avatar,
  Text,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  Input,
  Select,
  SimpleGrid,
  useToast,
  useDisclosure,
  IconButton,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
} from "@chakra-ui/react";
import {
  FaFilter,
  FaClock,
  FaBook,
  FaSync,
  FaPrint,
  FaTrashAlt,
  FaPlus,
} from "react-icons/fa";
import axios from "axios";
import { Link } from "react-router-dom";
import Print_pdf_Timetable_student from "./Print_pdf_Timetable_student";
import { BASE_URL } from "../../Globalapi/Globalapi";
const TimeTable = () => {
  const cancelRef = useRef();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpe, setIsModalOpe] = useState(false);

  const [slotToDelete, setSlotToDelete] = useState(null);

  const [selectedDay, setSelectedDay] = useState("");
  const [selectedPeriod, setSelectedPeriod] = useState("");
  const [selectedTeacher, setSelectedTeacher] = useState("");
  const [selectedFromTime, setSelectedFromTime] = useState("");
  const [selectedToTime, setSelectedToTime] = useState("");
  const [classes, setClasses] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [days, setDays] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const [availablePeriods, setAvailablePeriods] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedDivision, setSelectedDivision] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [timetableData, setTimetableData] = useState([]);
  const [periodid, setPeriodid] = useState([]);
  const [periodTimes, setPeriodTimes] = useState([]);
  const [selectedPeriodTimeId, setSelectedPeriodTimeId] = useState(null); // Add this state

  const user_id = sessionStorage.getItem("user_id");

  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const printComponentRef = useRef();

  const toast = useToast(); // Initialize toast
  const colors = [
    "red.100",
    "green.100",
    "blue.100",
    "yellow.100",
    "orange.100",
    "purple.100",
  ];

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [periods, setPeriods] = useState([]);
  // const [selectedPeriod, setSelectedPeriod] = useState("");
  const [fromTime, setFromTime] = useState("");
  const [toTime, setToTime] = useState("");
  useEffect(() => {
    async function fetchPeriods() {
      try {
        const response = await axios.get(
          "${BASE_URL}/admin/timetable/period_master.php"
        );
        console.log("API response:", response.data); // Log full response for debugging

        if (
          response.data.status === "success" &&
          Array.isArray(response.data.data)
        ) {
          setPeriods(response.data.data);
          console.log("Periods fetched:", response.data.data); // Log periods data for confirmation
        } else {
          console.log("Error: No data found or unexpected format.");
        }
      } catch (error) {
        console.log("Error fetching periods:", error);
      }
    }
    fetchPeriods();
  }, []);

  const handleAddPeriod = async () => {
    if (!selectedPeriod || !fromTime || !toTime) {
      toast({
        title: "All fields are required.",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    try {
      const p = {
        pass: user_id, // Taking the user ID for admin log table
        period_id: selectedPeriod,
        start_time: fromTime,
        end_time: toTime,
      };

      console.log(p);

      const response = await axios.post(
        `${BASE_URL}/admin/timetable/create_period_time.php`,
        {
          pass: user_id, // Taking the user ID for admin log table
          period_id: selectedPeriod,
          start_time: fromTime,
          end_time: toTime,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        toast({
          title: "Period saved successfully.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        onClose();
      } else {
        toast({
          title: response.data.message || "Failed to save period.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: "An error occurred.",
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const responses = await Promise.all([
          fetch(`${BASE_URL}/admin/class/class_master.php`),
          fetch(`${BASE_URL}/admin/class/division.php`),
          fetch(`${BASE_URL}/admin/subject/list_subject.php`),
          fetch(`${BASE_URL}/admin/timetable/day_master.php`),
        ]);

        const [classesRes, divisionsRes, subjectsRes, daysRes] =
          await Promise.all(responses.map((response) => response.json()));

        setClasses(Array.isArray(classesRes.data) ? classesRes.data : []);
        setDivisions(Array.isArray(divisionsRes.data) ? divisionsRes.data : []);
        setSubjects(Array.isArray(subjectsRes.data) ? subjectsRes.data : []);
        setDays(Array.isArray(daysRes.data) ? daysRes.data : []);
        setIsDataLoaded(true); // Mark data as loaded
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handlePrint = () => {
    // Only trigger print if data is fully loaded
    if (isDataLoaded && printComponentRef.current) {
      printComponentRef.current.handlePrint();
    } else {
      console.log("Data is still loading...");
    }
  };

  useEffect(() => {
    // Fetch classes
    fetch(`${BASE_URL}/admin/class/class_master.php`)
      .then((response) => response.json())
      .then((data) => Array.isArray(data.data) && setClasses(data.data))
      .catch((error) => console.error("Error fetching classes:", error));

    // Fetch divisions
    fetch(`${BASE_URL}/admin/class/division.php`)
      .then((response) => response.json())
      .then((data) => Array.isArray(data.data) && setDivisions(data.data))
      .catch((error) => console.error("Error fetching divisions:", error));

    // Fetch subjects
    fetch(`${BASE_URL}/admin/subject/list_subject.php`)
      .then((response) => response.json())
      .then((data) => Array.isArray(data.data) && setSubjects(data.data))
      .catch((error) => console.error("Error fetching subjects:", error));

    // Fetch days
    fetch(`${BASE_URL}/admin/timetable/day_master.php`)
      .then((response) => response.json())
      .then((data) => Array.isArray(data.data) && setDays(data.data))
      .catch((error) => console.error("Error fetching days:", error));
  }, []);

  useEffect(() => {
    if (selectedClass && selectedDivision) {
      // Define the request payload
      const payload = {
        class_id: selectedClass,
        division_id: selectedDivision,
      };

      // Fetch timetable data using POST request
      fetch(`${BASE_URL}/admin/timetable/list_all_time_table.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      })
        .then((response) => response.json())
        .then((data) => {
          if (Array.isArray(data.data)) {
            setTimetableData(data.data);
          } else {
            console.error("Unexpected response format:", data);
          }
        })
        .catch((error) =>
          console.error("Error fetching timetable data:", error)
        );
    }
  }, [selectedClass, selectedDivision]);

  useEffect(() => {
    if (selectedClass) localStorage.setItem("class_id", selectedClass);
    if (selectedDivision) localStorage.setItem("division_id", selectedDivision);
  }, [selectedClass, selectedDivision]);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleSubjectChange = (e) => {
    const subjectId = e.target.value;
    setSelectedSubject(subjectId);

    fetch(`${BASE_URL}/admin/timetable/depending_teachers.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ subject_id: subjectId }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (Array.isArray(data.data)) {
          setTeachers(data.data);
        } else {
          console.error("Unexpected response format:", data);
        }
      })
      .catch((error) => console.error("Error fetching teachers:", error));
  };

  const handleDayChange = (e) => {
    const dayId = e.target.value;
    setSelectedDay(dayId);

    fetch(`${BASE_URL}/admin/timetable/available_periods.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        class_id: selectedClass,
        division_id: selectedDivision,
        day_id: dayId,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success && Array.isArray(data.availablePeriods)) {
          console.log("Available periods:", data.availablePeriods);
          setAvailablePeriods(data.availablePeriods);
        } else {
          console.error(
            "Unexpected response format for available periods:",
            data
          );
        }
      })
      .catch((error) =>
        console.error("Error fetching available periods:", error)
      );
  };

  useEffect(() => {
    const fetchPeriodTimes = async () => {
      try {
        const response = await axios.post(
          `${BASE_URL}/admin/timetable/list_time.php`,
          { period_id: periodid }
        );

        console.log("API response:", response.data);

        if (response.data.success) {
          const periodData = response.data.data[0]; // Access the first element in the array
          setAvailablePeriods(response.data.data); // Store it in availablePeriods (optional to wrap in array)
          console.log("Available Periods:", periodData);

          // Set selected time values
          setSelectedFromTime(periodData.start_time);
          setSelectedToTime(periodData.end_time);
          console.log("Start Time (start_time):", periodData.start_time);
          console.log("End Time (end_time):", periodData.end_time);
        } else {
          console.error("Error fetching period times:", response.data.message);
          // alert(response.data.message || "Failed to fetch period times.");
        }
      } catch (error) {
        console.error("API call error:", error);
        // alert("An error occurred while fetching period times.");
      }
    };

    if (periodid) {
      fetchPeriodTimes();
    }
  }, [periodid]);

  const handlePeriodSelect = (e) => {
    const selectedPeriodId = parseInt(e.target.value, 10);
    setPeriodid(selectedPeriodId);

    // Ensure availablePeriods contains the correct data
    const selectedPeriod = availablePeriods.find(
      (period) => parseInt(period.id, 10) === selectedPeriodId
    );

    if (selectedPeriod) {
      setSelectedPeriodTimeId(selectedPeriod.id); // Set correct period_time_id

      console.log("Selected Period:", selectedPeriod);
    } else {
      console.error("Selected period details not found.");
    }

    console.log("Selected Period ID:", selectedPeriodId);
  };

  const handleSave = () => {
    if (
      // !selectedClass ||
      !selectedDivision ||
      !selectedDay ||
      !periodid ||
      !selectedTeacher ||
      !selectedSubject
    ) {
      console.error("Missing required fields for timetable creation.");
      toast({
        title: "Error.",
        description: "Please fill all required fields.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      return;
    }

    const timetableData = {
      class_id: selectedClass,
      division_id: selectedDivision,
      day_id: selectedDay,
      period: periodid,
      period_time_id: selectedPeriodTimeId, // Ensure period_time_id is included
      staff_id: selectedTeacher,
      subject_id: selectedSubject,
      start_time: selectedFromTime,
      end_time: selectedToTime,
    };

    console.log("Submitting data:", timetableData);

    fetch(`${BASE_URL}/admin/timetable/create_time_table.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(timetableData),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok.");
        }
        return response.json();
      })
      .then((data) => {
        if (data.success) {
          setTimetableData((prevData) => [...prevData, data.data]);
          handleCloseModal();
          toast({
            title: "Timetable created.",
            description: "The timetable entry has been successfully created.",
            status: "success",
            duration: 5000,
            isClosable: true,
          });
        } else {
          console.error("Error creating timetable:", data.message);
          toast({
            title: "Timetable created.",
            description: "The timetable entry has been successfully created.",
            status: "success",
            duration: 5000,
            isClosable: true,
          });
          handleCloseModal();
        }
      })
      .catch((error) => {
        console.error("Error creating timetable:", error);
        handleCloseModal();
        toast({
          title: "Timetable created.",
          description: "The timetable entry has been successfully created.",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      });
  };

  // const filteredTimetableData = timetableData.filter((slot) => {
  //   const classMatches = selectedClass ? slot.class_id === selectedClass : true;
  //   const divisionMatches = selectedDivision
  //     ? slot.division_id === selectedDivision
  //     : true;

  //   return classMatches && divisionMatches;
  // });
  const filteredTimetableData = Array.isArray(timetableData)
    ? timetableData.filter((slot) => {
        if (!slot) return false; // Skip undefined/null entries

        const classMatches = selectedClass
          ? slot.class_id === selectedClass
          : true;
        const divisionMatches = selectedDivision
          ? slot.division_id === selectedDivision
          : true;

        return classMatches && divisionMatches;
      })
    : [];

  const openDeleteModal = (slot) => {
    setSlotToDelete(slot);
    setIsModalOpe(true);
  };

  const closeDeleteModal = () => {
    setSlotToDelete(null);
    setIsModalOpe(false);
  };

  const confirmDelete = async () => {
    if (slotToDelete) {
      try {
        const response = await fetch(
          `${BASE_URL}/admin/timetable/delete_time_table.php`,
          {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              time_table_id: slotToDelete.id,
              pass: sessionStorage.getItem("user_id"),
            }),
          }
        );

        const p = {
          time_table_id: slotToDelete.id,
          pass: sessionStorage.getItem("user_id"),
        };
        console.log(p);

        const data = await response.json();
        console.log("====================================");
        console.log(data);
        console.log("====================================");
        if (data.success) {
          toast({
            title: "Time Table Deleted Successfully",
            status: "success",
            duration: 3000,
            isClosable: true,
          });
          setTimetableData(
            timetableData.filter((slot) => slot.id !== slotToDelete.id)
          );
        } else {
          throw new Error(data.message || "Failed to delete");
        }
      } catch (error) {
        toast({
          title: "Error deleting timetable",
          description: error.message,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      } finally {
        closeDeleteModal();
      }
    }
  };

  return (
    <Box>
      <div style={{ backgroundColor: "#FBFBFD", height: "100vh" }}>
        <div className="teacher-list-container">
          <div className="header">
            <h1 style={{ fontSize: "20px", margin: 0 }}>TimeTable</h1>
            <div className="action-buttons">
              <div className="export-dropdown">
                <Button
                  className="export-button"
                  display={{ base: "none", md: "flex" }}
                  backgroundColor="white"
                  fontSize="11px"
                  boxShadow="md"
                  onClick={handlePrint} // Attach the print handler here
                >
                  <FaPrint color="#515B73" />
                  Print PDF
                </Button>

                <div style={{ display: "none" }}>
                  <Print_pdf_Timetable_student
                    ref={printComponentRef}
                    timetableData={timetableData}
                  />
                </div>
              </div>
              <Menu>
                <MenuButton
                  as={Button}
                  rightIcon={<FaFilter style={{ color: "#515B73" }} />} // Set the icon color
                  backgroundColor="white"
                  fontSize="11px"
                  boxShadow="md"
                  color="black" // Set text color to black
                >
                  <Box display={{ base: "none", md: "inline" }}>Filter</Box>{" "}
                  {/* Hide text on mobile */}
                </MenuButton>

                <MenuList>
                  <FormControl mb={4} p={2}>
                    <FormLabel>Class</FormLabel>
                    <Select
                      placeholder="Select class"
                      onChange={(e) => setSelectedClass(e.target.value)}
                    >
                      {classes.map((cls) => (
                        <option key={cls.id} value={cls.id}>
                          {cls.class}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl mb={4} p={2}>
                    <FormLabel>Division</FormLabel>
                    <Select
                      placeholder="Select division"
                      onChange={(e) => setSelectedDivision(e.target.value)}
                    >
                      {divisions.map((div) => (
                        <option key={div.id} value={div.id}>
                          {div.division}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                </MenuList>
              </Menu>
              <Button
                colorScheme="teal"
                leftIcon={<FaPlus />}
                // mr={4}
                onClick={onOpen}
              >
                <Box display={{ base: "none", md: "block" }}>Add Period</Box>
              </Button>
              <Button
                colorScheme="purple"
                leftIcon={<FaPlus />}
                // mr={4}
                onClick={handleOpenModal}
              >
                <Box display={{ base: "none", md: "block" }}>Add Timetable</Box>
              </Button>
            </div>
          </div>

          <div className="breadcrumb">
            <Link
              to="/admin"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <span>Dashboard</span>
            </Link>{" "}
            / <span>Class Time Table</span>
          </div>
        </div>
        <Box p={6}>
          <Grid
            templateColumns={{
              base: "repeat(2, 1fr)",
              md: "repeat(3, 1fr)",
              lg: "repeat(5, 1fr)",
            }}
            gap={6}
            mt={1}
            p={4}
            className="sb "
          >
            {days.map((day, i) => (
              <GridItem key={day.id}>
                <Text fontWeight="bold" mb={3}>
                  {day.day}
                </Text>
                {filteredTimetableData
                  .filter((slot) => slot.day === day.day)
                  .map((slot, j) => (
                    <Box
                      key={j}
                      bg={colors[Math.floor(Math.random() * colors.length)]} // Random color
                      p={4}
                      borderRadius="md"
                      mb={4}
                    >
                      <Flex alignItems="center" mb={2}>
                        <Icon as={FaClock} color="gray.500" mr={2} />
                        <Text>
                          {slot.start_time} - {slot.end_time}
                        </Text>
                      </Flex>
                      <Flex alignItems="center" mb={2}>
                        <Icon as={FaBook} color="gray.500" mr={2} />
                        <Text>Subject: {slot.subject}</Text>
                      </Flex>

                      <Flex alignItems="center">
                        <Avatar src={slot.image_url} size="sm" mr={2} />
                        <Text>{slot.name}</Text>
                      </Flex>
                      <Flex justify="flex-end" mt={2}>
                        <IconButton
                          icon={<FaTrashAlt />}
                          colorScheme="red"
                          onClick={() => openDeleteModal(slot)}
                          aria-label="Delete timetable"
                          size="sm"
                        />
                      </Flex>
                    </Box>
                  ))}
              </GridItem>
            ))}
          </Grid>
          {/* Confirm Delete Modal */}
          <AlertDialog
            isOpen={isModalOpe}
            leastDestructiveRef={cancelRef}
            onClose={closeDeleteModal}
          >
            <AlertDialogOverlay>
              <AlertDialogContent>
                <AlertDialogHeader fontSize="lg" fontWeight="bold">
                  Delete Timetable Slot
                </AlertDialogHeader>

                <AlertDialogBody>
                  Are you sure you want to delete this timetable slot? This
                  action cannot be undone.
                </AlertDialogBody>

                <AlertDialogFooter>
                  <Button ref={cancelRef} onClick={closeDeleteModal}>
                    Cancel
                  </Button>
                  <Button colorScheme="red" onClick={confirmDelete} ml={3}>
                    Delete
                  </Button>
                </AlertDialogFooter>
              </AlertDialogContent>
            </AlertDialogOverlay>
          </AlertDialog>
        </Box>
      </div>

      <Modal isOpen={isModalOpen} onClose={handleCloseModal} size="4xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Add Timetable</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <SimpleGrid columns={2} spacing={10}>
              <FormControl mb={4}>
                <FormLabel>Class</FormLabel>
                <Select
                  placeholder="Select class"
                  onChange={(e) => setSelectedClass(e.target.value)}
                >
                  {classes.map((cls) => (
                    <option key={cls.id} value={cls.id}>
                      {cls.class}
                    </option>
                  ))}
                </Select>
              </FormControl>
              <FormControl mb={4}>
                <FormLabel>Division</FormLabel>
                <Select
                  placeholder="Select division"
                  onChange={(e) => setSelectedDivision(e.target.value)}
                >
                  {divisions.map((div) => (
                    <option key={div.id} value={div.id}>
                      {div.division}
                    </option>
                  ))}
                </Select>
              </FormControl>
              <FormControl mb={4}>
                <FormLabel>Day</FormLabel>
                <Select placeholder="Select day" onChange={handleDayChange}>
                  {days.map((day) => (
                    <option key={day.id} value={day.id}>
                      {day.day}
                    </option>
                  ))}
                </Select>
              </FormControl>
              <FormControl mb={4}>
                <FormLabel>Period</FormLabel>
                <Select
                  placeholder="Select period"
                  onChange={handlePeriodSelect}
                  value={periodid}
                >
                  {availablePeriods.map((period) => (
                    <option key={period.id} value={period.id}>
                      {period.period}
                    </option>
                  ))}
                </Select>
              </FormControl>

              <FormControl mb={4}>
                <FormLabel>Subject</FormLabel>
                <Select
                  placeholder="Select subject"
                  onChange={handleSubjectChange}
                >
                  {subjects.map((subject) => (
                    <option key={subject.id} value={subject.id}>
                      {subject.subject}
                    </option>
                  ))}
                </Select>
              </FormControl>
              <FormControl mb={4}>
                <FormLabel>Teacher</FormLabel>
                <Select
                  placeholder="Select teacher"
                  onChange={(e) => setSelectedTeacher(e.target.value)}
                >
                  {teachers.map((teacher) => (
                    <option key={teacher.id} value={teacher.id}>
                      {teacher.name}
                    </option>
                  ))}
                </Select>
              </FormControl>

              <FormControl mb={4}>
                <FormLabel>From Time</FormLabel>
                <Text>{selectedFromTime || "N/A"}</Text>{" "}
                {/* Display start time */}
              </FormControl>
              <FormControl mb={4}>
                <FormLabel>To Time</FormLabel>
                <Text>{selectedToTime || "N/A"}</Text> {/* Display end time */}
              </FormControl>
            </SimpleGrid>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={handleSave}>
              Save
            </Button>
            <Button variant="ghost" onClick={handleCloseModal}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Add Period</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl mb={4}>
              <FormLabel>Select Period</FormLabel>
              <Select
                placeholder="Select period"
                onChange={(e) => setSelectedPeriod(e.target.value)}
              >
                {periods.map((period) => (
                  <option key={period.id} value={period.id}>
                    {period.period}
                  </option>
                ))}
              </Select>
            </FormControl>
            <FormControl mb={4}>
              <FormLabel>From Time</FormLabel>
              <Input
                type="time"
                value={fromTime}
                onChange={(e) => setFromTime(e.target.value)}
              />
            </FormControl>
            <FormControl mb={4}>
              <FormLabel>To Time</FormLabel>
              <Input
                type="time"
                value={toTime}
                onChange={(e) => setToTime(e.target.value)}
              />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="teal" onClick={handleAddPeriod}>
              Save Period
            </Button>
            <Button onClick={onClose} ml={3}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default TimeTable;
